module.exports = __webpack_public_path__ + "static/media/bootloader-light.b7be4834.png";